import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        role: '',
        roleCode: 0,
        searchCTN: '',
        //二级菜单二级 为了在详情页人返回列表页的时候列表中依然有数据
        subClassId: 0
    },
    mutations: {
        whichRole(state, role) {
            state.role = role
        },
        roleCode(state, roleCode) {
            state.roleCode = roleCode
        },
        searchCTN(state, searchCTN) {
            state.searchCTN = searchCTN
        },
        subClassId(state, subClassId) {
            state.subClassId = subClassId
        },
    },
    actions: {},
    modules: {}
})